import Typography from '@mui/material/Typography';


const now = new Date(new Date().toISOString());


function timeAgo(datetime: Date) {
    const diff = now.valueOf() - datetime.valueOf();
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(weeks / 4);
    const years = Math.floor(months / 12);
    if (seconds < 60) {
        let s = "s"
        if (seconds === 1) {
            s = "";
        }
        return `${seconds} second${s} ago`;
    } else if (minutes < 60) {
        let s = "s"
        if (minutes === 1) {
            s = "";
        }
        return `${minutes} minute${s} ago`;
    } else if (hours < 24) {
        let s = "s"
        if (hours === 1) {
            s = "";
        }
        return `${hours} hour${s} ago`;
    } else if (days < 7) {
        let s = "s"
        if (days === 1) {
            s = "";
        }
        return `${days} day${s} ago`;
    } else if (weeks < 4) {
        let s = "s"
        if (weeks === 1) {
            s = "";
        }
        return `${weeks} week${s} ago`;
    } else if (months < 12) {
        let s = "s"
        if (months === 1) {
            s = "";
        }
        return `${months} month${s} ago`;
    } else {
        let s = "s"
        if (years === 1) {
            s = "";
        }
        return `${years} year${s} ago`;
    }
}


export function dateTimeText(datetime: Date, addTimeAgo: Boolean) {
    // Do we need to convert the datetime to UTC?
    const utc_datetime = new Date(Date.parse(datetime + 'Z'));
    const resultString = utc_datetime.toString();
    if (addTimeAgo) {
        return resultString + " - " + timeAgo(utc_datetime);
    }
    return resultString;
}


export function DateTimeWidget(props: any) {
    let dtText = props.dtText;
    if (dtText === undefined) {
        dtText = dateTimeText(props.dt, props.addTimeAgo);
    }

    // Do we need to convert the datetime to UTC?
    // const datetime = new Date(new Date(props.dt).toString() + " UTC");
    // const resultString = datetime.toString() + " - " + timeAgo(datetime);
    // const convertedDateTime = new Date(new Date(props.dt).toLocaleString());
    // const convertedDateTime = new Date(new Date(props.dt).toLocaleString('en-US', { timeZone: "America/Denver" }));
    return <Typography variant="body1" align="left" gutterBottom>{dtText}</Typography>
    // return <Typography variant="body1" align="left" gutterBottom>{datetime.toString()} - <TimeAgo date={datetime} /></Typography>
}
